export default __webpack_public_path__ + "static/media/quad.1ef672df.png";